module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-01.12d778b1.jpg";